import { render } from "./ArtistRow.vue?vue&type=template&id=47af08ec"
import script from "./ArtistRow.vue?vue&type=script&lang=js"
export * from "./ArtistRow.vue?vue&type=script&lang=js"
script.render = render

export default script